import React, { useState, createContext } from "react";

const ProductListContext = createContext();

function ProductListContextProvider(props) {
  const [tabList, setTabList] = useState([]);
  const [activeTab, setActiveTab] = useState();
  const [heroBanner, setHeroBanner] = useState();
  const [promoBanners, setPromoBanners] = useState();
  const [homeBanner, setHomeBanners] = useState();
  const [productsList, setProductsList] = useState([]);
  const [featuredProduct, setFeaturedProduct] = useState([]);
  const [pagination, setPagination] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [redirectURL,setRedirectUrl] =  useState();
  const value = {
    featuredProduct, 
    setFeaturedProduct,
    activeTab,
    setActiveTab,

    heroBanner,
    setHeroBanner,

    promoBanners,
    setPromoBanners,
    homeBanner,
    setHomeBanners,
    productsList,
    setProductsList,
    tabList,
    setTabList,
    pagination,
    setPagination,
    isOpen,
    setIsOpen,
    redirectURL,
    setRedirectUrl
  };

  return (
    <ProductListContext.Provider value={value}>
      {props.children}
    </ProductListContext.Provider>
  );
}
const ProductListContextConsumer = ProductListContext.Consumer;

export {
  ProductListContext,
  ProductListContextProvider,
  ProductListContextConsumer,
};
export default ProductListContextProvider;
